@file:OptIn(androidx.compose.material3.ExperimentalMaterial3Api::class)

package link.erpango.quip.ui

import androidx.compose.foundation.layout.height
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowBack
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import link.erpango.quip.theme.QuipColors
import org.jetbrains.compose.ui.tooling.preview.Preview

@Suppress("DEPRECATION")
@Composable
fun QuipTopAppBar(
    tile: String,
    modifier: Modifier = Modifier,
    showBackButton: Boolean = false,
    onBack: (() -> Unit)? = null,
    onBackVisibilityChange: ((Boolean) -> Unit)? = null,
    actions: @Composable androidx.compose.foundation.layout.RowScope.() -> Unit = {},
) {
    // TopAppBar siempre se dibuja; el botón de retroceso se muestra solo si showBackButton == true

    TopAppBar(
        navigationIcon = {
            if (showBackButton) {
                IconButton(onClick = {
                    // Ejecuta el callback principal
                    onBack?.invoke()
                    // Notificamos que el botón debería ocultarse (si el consumidor lo desea)
                    onBackVisibilityChange?.invoke(false)
                }) {
                    Icon(
                        imageVector = Icons.Filled.ArrowBack,
                        contentDescription = "Back",
                        tint = QuipColors.colorOnPrimary
                    )
                }
            }
        },
        title = {
            Text(
                text = tile,
                color = QuipColors.colorOnPrimary,
                style = MaterialTheme.typography.headlineMedium,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )
        },
        actions = actions,
        colors = TopAppBarDefaults.topAppBarColors(
             containerColor = QuipColors.colorPrimary,
             titleContentColor = QuipColors.colorOnPrimary,
             actionIconContentColor = QuipColors.colorOnPrimary
        ),
        modifier = modifier
    )
}

@Composable
@Preview
fun QuipTopAppBarPreview() {
    QuipTopAppBar(
        tile = "Quip App",
        modifier = Modifier
            .height(100.dp),
        showBackButton = true,
        onBack = {},
        onBackVisibilityChange = {}
    )
}